import React from 'react'

export default function NoPage() {
  return (
    <div>NoPage</div>
  )
}
